import { formatDateOnly } from '../../utils/dateTime';

// The heading above each day's times.
//
// "09/02/2026" alone makes the office do the conversion in their head — and the
// question staff are actually holding is "is that the Wednesday she asked for?".
// The weekday goes first because that is what is being checked.
//
// Built from the yyyy-mm-dd parts rather than from `new Date(str)`: a bare date
// string is parsed as UTC, so anywhere west of Greenwich — Chicago included —
// it lands on the day before and names the wrong weekday.
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function slotDayHeading(isoDay: string, dateFormat?: string | null): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDay || '').trim());
  if (!match) return String(isoDay || '');

  const [, y, m, d] = match;
  const local = new Date(Number(y), Number(m) - 1, Number(d));
  if (Number.isNaN(local.getTime())) return String(isoDay);

  return `${WEEKDAYS[local.getDay()]} · ${formatDateOnly(local, dateFormat)}`;
}
